"use strict";
/**
 * @file Created on 02.06.2020
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DateParser_1 = require("../../../core/model/data-dictionary/parsers/DateParser");

var StructPropBuilder_1 = require("../../../core/model/data-dictionary/StructPropBuilder");

var NotificationDoc_1 = require("../NotificationDoc");
/**
 * @author Jan Prokop
 */


var NChangedWinPriceValidity =
/*#__PURE__*/
function (_NotificationDoc_1$No) {
  _inherits(NChangedWinPriceValidity, _NotificationDoc_1$No);

  function NChangedWinPriceValidity(windowId, newPriceValidityStart, newPriceValidityEnd, oldPriceValidityStart, oldPriceValidityEnd) {
    var _this;

    _classCallCheck(this, NChangedWinPriceValidity);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(NChangedWinPriceValidity).call(this));
    _this.windowId = windowId;
    _this.newPriceValidityStart = newPriceValidityStart;
    _this.newPriceValidityEnd = newPriceValidityEnd;
    _this.oldPriceValidityStart = oldPriceValidityStart;
    _this.oldPriceValidityEnd = oldPriceValidityEnd;
    return _this;
  }
  /**
   * Converter from data-dictionary representation
   */


  _createClass(NChangedWinPriceValidity, null, [{
    key: "fromDataDict",
    value: function fromDataDict(mat) {
      return new NChangedWinPriceValidity(mat.windowId, mat.newPriceValidityStart, mat.newPriceValidityEnd, mat.oldPriceValidityStart, mat.oldPriceValidityEnd);
    }
  }]);

  return NChangedWinPriceValidity;
}(NotificationDoc_1.NotificationDoc);

exports.NChangedWinPriceValidity = NChangedWinPriceValidity;

NChangedWinPriceValidity.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(NChangedWinPriceValidity.name);
  return {
    windowId: builder.id('windowId'),
    newPriceValidityStart: builder.opt(builder.date('newPriceValidityStart', DateParser_1.DateParser.ISO_PATTERN)),
    newPriceValidityEnd: builder.opt(builder.date('newPriceValidityEnd', DateParser_1.DateParser.ISO_PATTERN)),
    oldPriceValidityStart: builder.opt(builder.date('oldPriceValidityStart', DateParser_1.DateParser.ISO_PATTERN)),
    oldPriceValidityEnd: builder.opt(builder.date('oldPriceValidityEnd', DateParser_1.DateParser.ISO_PATTERN))
  };
}();